import { OrderedListOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'

// Sharable styled button for opening drawers like on Swing Report & Driver Forms

type OpenDrawerButtonProps = {
  disabled?: boolean
  onClick?: () => void
  extraButtonProps?: object
}

export function OpenDrawerButton({ disabled, onClick, extraButtonProps }: OpenDrawerButtonProps) {
  return (
    <Button
      type='link'
      disabled={disabled}
      onClick={onClick}
      icon={<OrderedListOutlined className='pt-1' />}
      style={{ margin: '0', padding: '0 0 0 1em' }}
      size='small'
      {...extraButtonProps}
    >
      View
    </Button>
  )
}
